export class Stedfesting {
    constructor(
        readonly veglenkesekvensid: number,
        readonly kortform: string,
        readonly startposisjon: number,
        readonly sluttposisjon: number,
        readonly retning: 'MED' | 'MOT',
        readonly sideposisjon: string | null = null,
        readonly kjørefelt: string[] | null = null,
        readonly type: string
    ) {}
}
